<template>
    <button
        class="a-service-button service-button"
        type="button"
        @click="onClick"
        :aria-label="`${ariaLabel}${t(item, 'name')}`"
    >
        <span class="service-button__icon-container">
            <img 
                class="service-button__icon"
                :alt="`${$t('service-button_icon')} ${t(item, 'name')}`"
                :src="t(item, 'icon')"
            >
        </span>
        {{ t(item, 'name') }}
    </button>
</template>

<script>

import { mapGetters } from 'vuex';

export default {
    name: "AServiceButton",
    props: {
        item: {
            type: Object,
            default: () => ({})
        },
        ariaLabel: {
            type: String,
            default: 'Service button'
        }
    },
    computed: {
        ...mapGetters([
            't'
        ])
    },
    methods: {
        onClick() {
            this.$emit('onClick', this.item);
        }
    }
}
</script>

<style lang="scss">
@import "a-service-button";
</style>
